import { render } from "./menuAdmin.vue?vue&type=template&id=e6031010&scoped=true"
import script from "./menuAdmin.vue?vue&type=script&lang=js"
export * from "./menuAdmin.vue?vue&type=script&lang=js"

import "./menuAdmin.vue?vue&type=style&index=0&id=e6031010&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/mFokeeiy/0/bpavone/detect-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6031010"]])

export default __exports__